import { useState, useEffect } from 'react';

export function useIsIframed() {
  const [isIframed, setIsIframed] = useState(false);

  useEffect(() => {
    try {
      setIsIframed(window.self !== window.top);
    } catch {
      setIsIframed(true); // fallback for weird cases
    }
  }, []);

  return isIframed;
}
